import { combineReducers } from "redux";
import {robotsReducer} from './robot';
import rootRobotDetailsReducer from '../robotDetails/reducer/reducer';
const rootRobotsReducer = combineReducers({
  robotsReducer: robotsReducer,
  rootRobotDetailsReducer: rootRobotDetailsReducer
});
export default rootRobotsReducer;
